export default "__VITE_ASSET__BfGRDUeR__"